// extracted by mini-css-extract-plugin
export default {"container":"DialogTitle_container__ItedR","container__fullscreen":"DialogTitle_container__fullscreen__8IcKS"};